import { Pet } from 'src/app/auth/_models/pet';
import { Observable } from 'rxjs/Observable';
import { AngularFirestoreCollection, AngularFirestore } from 'angularfire2/firestore';
import { Appointment } from './../_models/appointment';
import { Injectable } from '@angular/core';
import { isNullOrUndefined } from 'util';

@Injectable()
export class AppointmentService {

    constructor(private _firestore: AngularFirestore) { }

    private appointmentCollection: AngularFirestoreCollection<Appointment>;

    /**
     * Retorna lista de consultas de um Pet
     * @param pet - Objeto Pet
     * @param status - 0 : Pendentes / 1 : Cancelados / 2 : Finalizados
     */
    getAppointments(pet: Pet, status?: number): Observable<Appointment[]> {

        if (!isNullOrUndefined(status)) {
            this.appointmentCollection = this._firestore.collection<Appointment>('pets/' + pet.uuid + '/appointments/', ref =>
                ref
                    .where('status', '==', status));
        } else {
            this.appointmentCollection = this._firestore.collection<Appointment>('pets/' + pet.uuid + '/appointments/', ref =>
                ref
                    .orderBy('status', 'asc'));
        }

        return this.appointmentCollection.snapshotChanges().map(o => {
            return o.map(item => {
                const data = item.payload.doc.data();
                const uuid = item.payload.doc.id;

                if (data.start) {
                    if (typeof data.start.toDate === 'function') {
                        data.start = data.start.toDate();
                    }
                }

                if (data.end) {
                    if (typeof data.end.toDate === 'function') {
                        data.end = data.end.toDate();
                    }
                }

                return new Appointment({ ...{ uuid: uuid }, ...data });
            });

        });

    }

    /**
    * Insere um item de Consulta no Pet
    * @param pet
    * @param appointment
    */
    insertAppointment(pet: Pet, appointment: any) {
        return this
            ._firestore
            .collection('pets')
            .doc(pet.uuid)
            .collection('appointments')
            .add(appointment);
    }

    /**
    * Remove um item de Consulta no Pet
    * @param pet
    * @param uuid
    */
    removeAppointment(pet: Pet, uuid: string) {
        return this
            ._firestore
            .collection('pets')
            .doc(pet.uuid)
            .collection('appointments').doc(uuid).delete();
    }

    /**
    * Edita a data de uma consulta
    * @param pet
    * @param event
    */
    editAppointment(pet: Pet, event: any) {

        // if (event.start) {
        //     if (typeof event.start.toDate === 'function') {
        //         event.start = event.start.toDate();
        //     }
        // }

        // if (event.end) {
        //     if (typeof event.end.toDate === 'function') {
        //         event.end = event.end.toDate();
        //     }
        // }

        return this
            ._firestore
            .doc('pets/' + pet.uuid)
            .collection('appointments')
            .doc(event.uuid)
            .set(event, { merge: true });
    }

}
